/* eslint-disable max-len */
import { keyframes } from 'styled-components';
// import mediaWidth from '../../../utils/mediaWidth/mediaWidth';
import pointsData from '../../PhaserComponent/data/pointsData';
import screenData from '../../PhaserComponent/data/screenData';
import gameConfig from '../../PhaserComponent/config';
import pageParams from '../../PhaserComponent/pageParams';
import animationState from './animationStates';
import { hiddenPosition } from '../../PhaserComponent/StartLogo/hideAnimation';

const showAnimation = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

const getMazePositionAnimation = (pointId) => {
    const data = pointsData.find(({ id }) => id === pointId);
    const { x, y, diameter: { start, finish } } = data[pageParams.screenSize];
    const mazeX = x.maze - x.start;
    const mazeY = y.maze - y.start;
    const scaleParam = Math.round((100 * start) / finish) / 100;
    let keyframe = null;
    if (pageParams.screenSize === 's' || pageParams.screenSize === 'm') {
        keyframe = keyframes`
            0% {
                opacity: 1;
                transform: translateX(0px) translateY(0px) scale(${scaleParam})
            }
            100% {
                opacity: 1;
                transform: translateX(${mazeX}px) translateY(${mazeY}px) scale(${scaleParam})
            }
        `;
    } else {
        const track = Math.abs(hiddenPosition);
        const turnPointX = (track ** 2 - mazeX ** 2 - mazeY ** 2) / (-2 * (mazeX + track));
        const durationBeforeTurn = (Math.abs(turnPointX) * gameConfig.startAnimationDuration)
            / track;
        const percentBeforeTurn = Math.round((100 / gameConfig.startAnimationDuration)
             * durationBeforeTurn);
        keyframe = keyframes`
            0% {
                opacity: 1;
                transform: translateX(0px) translateY(0px) scale(${scaleParam})
            }
            ${percentBeforeTurn}% {
                opacity: 1;
                transform: translateX(${turnPointX}px) translateY(0px) scale(${scaleParam})
            }
            100% {
                opacity: 1;
                transform: translateX(${mazeX}px) translateY(${mazeY}px) scale(${scaleParam})
            }
        `;
    }
    return keyframe;
};

const getSitePositionAnimation = (pointId) => {
    const data = pointsData.find(({ id }) => id === pointId);
    const { x, y, diameter: { start, finish } } = data[pageParams.screenSize];
    const { width, height } = screenData[pageParams.screenSize];
    const mazeX = x.maze - x.start;
    const mazeY = y.maze - y.start;
    // const siteX = x.finish - x.start;
    // const siteY = y.finish - y.start;
    const siteX = x.finish < pageParams.clientWidth / 2
        ? x.finish - x.start - pageParams.offsetLeft
        : pageParams.clientWidth - (width - x.finish) - x.start - pageParams.offsetLeft;
    const siteY = y.finish < pageParams.clientHeight / 2
        ? y.finish - y.start - pageParams.offsetTop
        : pageParams.clientHeight - (height - y.finish) - y.start - pageParams.offsetTop;
    const scaleParam = Math.round((100 * start) / finish) / 100;

    const keyframe = keyframes`
            0% {
                opacity: 1;
                transform: translateX(${mazeX}px) translateY(${mazeY}px) scale(${scaleParam})
            }
            100% {
                opacity: 1;
                transform: translateX(${siteX}px) translateY(${siteY}px) scale(1)
            }
        `;

    return keyframe;
};

export default {
    [animationState.NONE]: {
        name: {
            topRight: 'none',
            bottomLeft: 'none',
            bottomRight: 'none',
        },
        duration: '0s',
    },
    [animationState.LOGO_POSITION]: {
        name: {
            topRight: 'none',
            bottomLeft: 'none',
            bottomRight: 'none',
        },
        duration: '0s',
    },
    [animationState.START_SHOW]: {
        name: {
            topRight: showAnimation,
            bottomLeft: showAnimation,
            bottomRight: showAnimation,
        },
        duration: '1s',
        timingFunction: 'ease-in-out',
    },
    [animationState.TAKE_MAZE_POSITION]: {
        name: {
            topRight: getMazePositionAnimation('topRight'),
            bottomLeft: getMazePositionAnimation('bottomLeft'),
            bottomRight: getMazePositionAnimation('bottomRight'),
        },
        duration: `${gameConfig.startAnimationDuration}ms`,
        timingFunction: pageParams.screenSize === 's'
            || pageParams.screenSize === 'm' ? 'ease-in-out' : 'linear',
    },
    [animationState.TAKE_SITE_POSITION]: {
        name: {
            topRight: getSitePositionAnimation('topRight'),
            bottomLeft: getSitePositionAnimation('bottomLeft'),
            bottomRight: getSitePositionAnimation('bottomRight'),
        },
        duration: `${gameConfig.finishAnimationDuration}ms`,
        timingFunction: 'cubic-bezier(.55,0,.45,1)',
    },
};
